const e = {
  name: "NavigationExpand",
  dimensions: { width: 20, height: 20 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2929 13.2929C9.90237 13.6834 9.90237 14.3166 10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289L11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289C9.90237 5.68342 9.90237 6.31658 10.2929 6.70711L13.5858 10L10.2929 13.2929Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 20H17C18.6523 20 20 18.6523 20 17V3C20 1.34772 18.6523 0 17 0H3C1.34772 0 0 1.34772 0 3V17C0 18.6523 1.34772 20 3 20ZM3 2C2.45228 2 2 2.45228 2 3V17C2 17.5477 2.45228 18 3 18H6V2H3ZM8 2V18H17C17.5477 18 18 17.5477 18 17V3C18 2.45228 17.5477 2 17 2H8Z" fill="currentColor"/>
    `
};
export {
  e as NavigationExpand
};
